/**
 * Created by staffanrantzow on 16/03/16.
 */

/* @flow */
import React, {PropTypes } from 'react';
import Translate from 'react-translate-component';

export class NotificationCheckBoxes extends React.Component {

  static propTypes = {
    values: PropTypes.object.isRequired,
    callback: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      values: this.props.values
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick (e) {
    var values, name;

    values = this.state.values;
    name = e.target.name;

    values[name].value = e.target.checked;

    this.setState({values: values}, function () {
      this.callCallback(name, values[name]);
    });
  }

  /**
   * Required function when you have the checked attribute on a checkbox
   */
  onChange (e) {}

  callCallback (name, obj) {
    this.props.callback(name, obj);
  }

  render () {
    const defaultClasses = 'styled-wrapper right';
    return (
      <div className='setting-checkboxes'>
        <div className='section'>
          <h3><Translate content='SALARY_INFORMATION'/></h3>
          <div className={defaultClasses}>
            <input
              type="checkbox"
              id="receiveSmsNotifications"
              name="receiveSmsNotifications"
              onChange={this.onChange}
              onClick={this.handleClick}
              checked={this.state.values.receiveSmsNotifications.value}
              />
            <label htmlFor='receiveSmsNotifications'>
              <span></span>
              <Translate content='SALARY_INFORMATION_VIA_SMS' />
            </label>
          </div>
          <div className={`${defaultClasses} margin-multiple-rows`}>
            <input
              type="checkbox"
              id="receiveEmailNotifications"
              name="receiveEmailNotifications"
              onChange={this.onChange}
              onClick={this.handleClick}
              checked={this.state.values.receiveEmailNotifications.value}
              />
            <label htmlFor='receiveEmailNotifications'>
              <span></span>
              <Translate content='SALARY_INFORMATION_VIA_EMAIL' />
            </label>
          </div>
        </div>
      </div>
    );
  }
}

export default NotificationCheckBoxes;



/** WEBPACK FOOTER **
 ** ./src/views/settings/salary-info/check-boxes/notification.js
 **/